import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-journey',
  templateUrl: './journey.component.html',
  styleUrls: ['./journey.component.scss']
})
export class JourneyComponent {
  @Input() feature: any;
  @Output() featureChange = new EventEmitter<any>();

  trainLines = [
    { id: 0, name: "Avanti West Coast", value: "VT" },
    { id: 1, name: "C2C", value: "c2c" }
  ];

  ngOnInit() {
    if (!this.feature.value) {
      this.feature.value = {
        selectedTrainLine: this.trainLines[0],
        stations: ''
      };
    }
  }

  onTrainLineChange() {
    this.featureChange.emit(this.feature);
  }

  onStationsChange() {
    this.featureChange.emit(this.feature);
  }
}